// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__9aq83","notes":"Notes_notes__1FLok"};